import { unstable_batchedUpdates } from 'react-dom';
var ModeTracker = /** @class */ (function () {
    function ModeTracker() {
        this.listeners = [];
    }
    ModeTracker.prototype.handler = function () {
        var _this = this;
        unstable_batchedUpdates(function () {
            _this.listeners.forEach(function (listener) { return listener.callback(listener.element); });
        });
    };
    ModeTracker.prototype.setup = function () {
        this.rootSearchObserver = new MutationObserver(this.handler.bind(this));
        this.rootSearchObserver.observe(document.body, { attributes: true, subtree: true });
    };
    ModeTracker.prototype.shutdown = function () {
        this.rootSearchObserver.disconnect();
    };
    ModeTracker.prototype.attach = function (listener) {
        var _this = this;
        if (this.listeners.length === 0) {
            this.setup();
        }
        this.listeners.push(listener);
        return function () {
            _this.listeners = _this.listeners.filter(function (l) { return l !== listener; });
            if (_this.listeners.length === 0) {
                _this.shutdown();
            }
        };
    };
    return ModeTracker;
}());
export default ModeTracker;
//# sourceMappingURL=mode-tracker.js.map